import { Injectable} from '@angular/core';
import { IStorageService, Storage, StorageKey } from './storage.type';

@Injectable({
  providedIn: 'root'
})
export class StorageService implements IStorageService {
  private static instance: StorageService;
  private storage: Storage;

  constructor() {
    // TODO: fix issue with @Inject. Do it only if session storage will need
    this.storage = localStorage;
  }

  /* istanbul ignore next */
  public static getInstance(): StorageService {
    if (!StorageService.instance) {
      StorageService.instance = new StorageService();
    }
    return StorageService.instance;
  }

  setItem(key: StorageKey, value: any): void {
    this.storage.setItem(key, JSON.stringify(value));
  }

  getItem<T>(key: StorageKey): T | null {
    const item = this.storage.getItem(key);
    return item ? JSON.parse(item) : null;
  }

  removeItem(key: string): void {
    this.storage.removeItem(key);
  }

  clear(): void {
    this.storage.clear();
  }

  test_getStorage(): Storage {
    return this.storage;
  }
}
